import React from "react";
import CustomButton from "components/CustomButton";
import Loader from "components/Loader";
export default ({
  nextQuestion,
  questionCount,
  handleOnSubmit,
  saveLoading,
  clickSubmitName,
}) => {
  return (
    <>
      <div className="assessmentAction">
        <CustomButton
          buttonClass="btn assessmentActionButton"
          onClick={
            questionCount !== 5
              ? () => nextQuestion("skip", questionCount)
              : () => handleOnSubmit("skip")
          }
        >
          {questionCount !== 5 ? (
            "Skip"
          ) : saveLoading && clickSubmitName === "skip" ? (
            <Loader width={40} height={24} />
          ) : (
            "Skip & Submit"
          )}
        </CustomButton>
        <CustomButton
          buttonClass="btn assessmentActionButton"
          onClick={
            questionCount !== 5
              ? () => nextQuestion("next", questionCount)
              : () => handleOnSubmit("submit")
          }
        >
          {questionCount !== 5 ? (
            "Next"
          ) : saveLoading && clickSubmitName === "submit" ? (
            <Loader width={40} height={24} />
          ) : (
            "Submit"
          )}
        </CustomButton>
      </div>
    </>
  );
};
